module.exports = __webpack_public_path__ + "static/media/fetchMFADataQuery.e7cf2081.graphql";